//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import html2canves from 'html2canvas';
import imgtoast from "../common/imgtoast";
  export default {
      name: "leaderboard",
    data(){
        return {
          tabIndex:0,
          rankdata:[],
            img:''
        }
    },
      components:{
          imgtoast
      },
    methods:{
        capture(){
          this.$vux.loading.show({
            text:'生成截图'
          })
          html2canves(this.$refs.screenshot,{
            useCORS:true
          }).then((canves)=>{
            let dataUrl=canves.toDataURL('image/png');
            // var a = document.createElement('a');
            // var event = new MouseEvent('click');
            // a.download = 'gaishi_'+new Date().getTime()+'.png';
            // a.href = dataUrl;
            // a.dispatchEvent(event);
            this.img=dataUrl;
            this.$vux.loading.hide();
            // })
          })
        },
      getRanking(){
        this.axios.post('/xcx/User/ranking').then(res=>{
          this.rankdata=res.data.data
        })
      },
      getLocation(){
          this.$wechat.getLocation({
            type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            success: function (res) {
              console.log(res);
              var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
              var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
              var speed = res.speed; // 速度，以米/每秒计
              var accuracy = res.accuracy; // 位置精度
            }
          })
      },
      share(){
          this.$wechat.showMenuItems({
            menuList: [
              'menuItem:share:timeline'
            ] // 要显示的菜单项，所有menu项见附录3
          });
      }
    },
    created() {
      this.getRanking();
    },
    watch:{
      tabIndex(val){
        if(val==1){
          this.getLocation();
        }
        this.getRanking();
      }
    }
  }



// WEBPACK FOOTER //
// ./src/components/leaderboard/leaderboard.vue